import angular from "angular";

VacationCtrl.$inject = [
  "$scope",
  "Vacation",
  "timeTravelMoment",
  "KcList",
  "moment",
  "Login",
];

export default function VacationCtrl(
  $scope,
  Vacation,
  timeTravelMoment,
  KcList,
  moment,
  Login,
) {
  // Initial scope setup
  initializeScope();

  // Initialize date range
  initializeDateRange();

  // Load Subordinate data if the user is a chef
  loadSubordinateData();

  // Initialize dropdown settings
  initializeDropdownSettings();

  // Controller functions
  $scope.getHeader = getHeader;
  $scope.getExportHeader = getExportHeader;
  $scope.csvdata = getExportData;
  $scope.getExportData = getExportData;
  $scope.updatePeriod = updatePeriod;
  $scope.vacationdata = populateExportData;
  $scope.kallejonka = calculateWorkHours;
  $scope.fetchVacation = fetchVacation;
  $scope.getDayClass = getDayClass;
  $scope.getDayTitle = getDayTitle;


  // Functions Definitions

  function initializeScope() {
    $scope.fte = [];
    $scope.formData = {
      dateTo: null,
      dateFrom: null,
    };
    $scope.opened1 = false;
    $scope.opened2 = false;
    $scope.dateOptions = {
      "year-format": "'yy'",
      "show-weeks": true,
      "starting-day": 1,
    };
    $scope.daFormat = "yyyy Vww";
    $scope.message = "Semester";
    $scope.header = [];
    $scope.custMode = { external: true, internal: true };
    $scope.groupMode = "A";
    $scope.timeMode = "A";
    $scope.sumMode = "A";
  }

  function fixWeekDates(from, to) {
    const firstDayOfMonthWeek = from.startOf("month").startOf('isoWeek');
    const lastDayOfMonthWeek = to.endOf("month").endOf('isoWeek');
    return [firstDayOfMonthWeek, lastDayOfMonthWeek]
  }

  function initializeDateRange() {
    const now = moment().startOf("day");

    const stop = now.clone().add(2, "month").endOf("month");
    const [firstDayOfMonthWeek, lastDayOfMonthWeek] = fixWeekDates(now, stop);

    $scope.momentStart = firstDayOfMonthWeek;
    $scope.formData.dateFrom = $scope.momentStart.toDate();

    $scope.momentStop = lastDayOfMonthWeek
    $scope.formData.dateTo = $scope.momentStop.toDate();
  }

  function loadSubordinateData() {
    Login.promise
      .then(() => {
        if (Login.isKc() || Login.isAdmin()) {
          KcList.get(
            {},
            (data) => {
              $scope.Subordinate = data;
              return data;
            },
            () => null
          );
        }
      })
      .catch((error) => console.log("kan det stämma %s", error));
  }

  function initializeDropdownSettings() {
    $scope.myDropdownOptions = [
      { id: "S", label: "Standard" },
      { id: "I", label: "Intermediate" },
      { id: "B", label: "Best available" },
    ];
    $scope.myDropdownModel = [$scope.myDropdownOptions[0]];
    $scope.myDropdownSettings = {
      styleActive: true,
      checkBoxes: true,
      alwaysOpened: true,
      displayProp: "name",
      smartButtonMaxItems: 10,
    };
  }

  function getHeader() {
    return $scope.header;
  }

  function getExportData() {
    return $scope.exportData;
  }

  function updatePeriod(dir) {
    $scope.momentStart = moment($scope.formData.dateFrom, "YYYY-MM-DD");
    $scope.momentStop = moment($scope.formData.dateTo, "YYYY-MM-DD");

    //console.log("Updating period with direction:", dir);
    //console.log("Current start date:", $scope.momentStart.format("YYYY-MM-DD"));
    //console.log("Current stop date:", $scope.momentStop.format("YYYY-MM-DD"));

    if (dir === -1) {
      //$scope.momentStart.subtract(1, "months").startOf("month");
      //$scope.momentStop.subtract(1, "months").endOf("month");
      $scope.momentStart.subtract(4, "weeks");
      $scope.momentStop.subtract(4, "weeks");
    } else {
      //$scope.momentStart.add(1, "months").startOf("month");
      //$scope.momentStop.add(1, "months").endOf("month");
      $scope.momentStart.add(4, "weeks");
      $scope.momentStop.add(4, "weeks");
    }

    //console.log("New start date:", $scope.momentStart.format("YYYY-MM-DD"));
    //console.log("New stop date:", $scope.momentStop.format("YYYY-MM-DD"));


    //const [firstDayOfMonthWeek, lastDayOfMonthWeek] = fixWeekDates($scope.momentStart, $scope.momentStop);

    $scope.momentStart.startOf('isoWeek');
    $scope.momentStop.endOf('isoWeek');

    //console.log("Adjusted start date:", $scope.momentStart.format("YYYY-MM-DD"));
    //console.log("Adjusted stop date:", $scope.momentStop.format("YYYY-MM-DD"));

    $scope.formData.dateFrom = $scope.momentStart.toDate();
    $scope.formData.dateTo = $scope.momentStop.toDate();
  }

  function populateExportData(head, inv, index, row) {
    if (!$scope.exportData[row]) {
      $scope.exportData[row] = [];
    }

    const exportValue = (value) =>
      value ? value.toLocaleString("sv-SE", { useGrouping: false }) : null;

    const exportCases = {
      NPC: inv.name,
    };

    Object.keys(inv)
      .filter((key) => Number(key))
      .forEach((key) => {
        exportCases["V " + key] = inv[key];
      });

    $scope.exportData[row][index] = exportCases[head] || null;
    return $scope.exportData[row][index];
  }

  function calculateWorkHours(from, to) {
    const momentStart = moment($scope.formData.dateFrom);
    const momentStop = moment($scope.formData.dateTo);

    let workHours = 0;
    const periods = {};

    for (let day = moment(momentStart); day <= momentStop; day.add(1, "days")) {
      if (
        timeTravelMoment.isRedDayMoment(day) ||
        timeTravelMoment.isWeekendDay(day)
      ) {
        continue;
      }

      const month = day.month() + 1;
      if (!periods[month]) {
        periods[month] = 0;
      }
      periods[month] += 8;
      workHours += 8;
    }

    $scope.periodHours = periods;
  }

  function fetchVacation() {
    //console.log("fetchVacation called");
    $scope.vacation = [];
    $scope.exportData = [];

    setupHeaders();
    const ids = $scope.fte.map((fte) => fte.employee_id);

    $scope.weekListMoment = timeTravelMoment.getWeekListDates(
      moment($scope.formData.dateFrom),
      moment($scope.formData.dateTo)
    );

    //console.log($scope.weekListMoment);

    processHeaderData($scope.weekListMoment);
    //console.log("Header after processing:", $scope.header);

    $scope.orgStruct = [];
    let lastWeekNumber = null;
    let currentWeekGroup = null;

    for (let index = 0; index < $scope.weekListMoment.length; index++) {
      const weekDayElement = $scope.weekListMoment[index];

      // Skip weekend days (Saturday = 6, Sunday = 7 in ISO)
      if (weekDayElement.weekIndex > 5) {
        continue;
      }

      if (weekDayElement.weekNumber !== lastWeekNumber) {
        lastWeekNumber = weekDayElement.weekNumber;
        currentWeekGroup = [];
        $scope.orgStruct.push(currentWeekGroup);
      }

      currentWeekGroup.push({
        header: weekDayElement.header,
        redDay: weekDayElement.redDay,
        weekIndex: weekDayElement.weekIndex,
        weekNumber: weekDayElement.weekNumber,
        semester: false,
        parentalLeave: false,
      });
    }


    Vacation.get(
      {
        id: ids,
        subTotal: $scope.subTotal,
        details: $scope.details,
        sum: $scope.sumMode,
        custMode: $scope.custMode,
        per: $scope.timeMode,
        type: $scope.groupMode,
        from: moment($scope.formData.dateFrom).format("YYYY-MM-DD"),
        to: moment($scope.formData.dateTo).format("YYYY-MM-DD"),
      },
      processVacationData
    );
  }

  function setupHeaders() {
    $scope.header = ["NPC"];
    $scope.weekHeaders = [];
  }

  function processHeaderData(data) {
    $scope.vacation = data;
    const weeks = [];
    let currentWeek = [];

    for (const day of data) {
      if (timeTravelMoment.isWeekendDay(day.header)) {
        continue;
      }

      if (currentWeek.length > 0 && day.weekNumber !== currentWeek[0].weekNumber) {
        weeks.push(currentWeek);
        currentWeek = [];
      }

      currentWeek.push(day);
    }

    if (currentWeek.length > 0) {
      weeks.push(currentWeek);
    }

    $scope.weekHeaders = weeks.map((week) => ({
      weekNumber: week[0].weekNumber,
      dateRange: `${week[0].header.format("D/M")} - ${week[week.length - 1].header.format("D/M")}`,
    }));

    $scope.header = ["NPC", ...$scope.weekHeaders.map((w) => w.weekNumber)];
  }

  function processVacationData(data) {
    for (let index = 0; index < data.length; index++) {
      const arr = (data[index].vacation_dates || "").split(",");
      if (arr.length === 1 && arr[0] === "") {
        data[index].vacation_dates = [];
      } else {
        data[index].vacation_dates = [...arr];
      }

      const parr = (data[index].parental_leave_dates || "").split(",");
      if (parr.length === 1 && parr[0] === "") {
        data[index].parental_leave_dates = [];
      } else {
        data[index].parental_leave_dates = [...parr];
      }
    }

    for (let index1 = 0; index1 < data.length; index1++) {
      data[index1].manglat = angular.copy($scope.orgStruct);

      for (let index2 = 0; index2 < data[index1].vacation_dates.length; index2++) {
        for (let i in data[index1].manglat) {
          for (let j in data[index1].manglat[i]) {
            if (data[index1].manglat[i][j].header.format("YYYY-MM-DD") === data[index1].vacation_dates[index2]) {
              data[index1].manglat[i][j].semester = true;
            }
          }
        }
      }

      for (let index2 = 0; index2 < data[index1].parental_leave_dates.length; index2++) {
        for (let i in data[index1].manglat) {
          for (let j in data[index1].manglat[i]) {
            if (data[index1].manglat[i][j].header.format("YYYY-MM-DD") === data[index1].parental_leave_dates[index2]) {
              data[index1].manglat[i][j].parentalLeave = true;
            }
          }
        }
      }
    }

    $scope.vacationData = data;
  }

  function getDayClass(day) {
    if (!day) return "";
    if (day.semester && day.parentalLeave) {
      return "is-combined-day";
    }
    if (day.semester) {
      return "is-semester-day";
    }
    if (day.parentalLeave) {
      return "is-parental-day";
    }
    if (day.redDay) {
      return "is-red-day";
    }
    return "";
  }

  function getDayTitle(day) {
    if (!day || !day.header) return "";
    const dateStr = day.header.format("YYYY-MM-DD");
    const labels = [];
    if (day.semester) {
      labels.push("Semester");
    }
    if (day.parentalLeave) {
      labels.push("Föräldraledig");
    }
    if (day.redDay) {
      labels.push(day.redDay);
    }
    return labels.length > 0 ? `${dateStr} (${labels.join(", ")})` : dateStr;
  }

  function getExportHeader() {
    const headers = ["NPC"];
    ($scope.weekHeaders || []).forEach((week) => {
      headers.push(`V ${week.weekNumber} Sem`);
      headers.push(`V ${week.weekNumber} Föräldr`);
    });
    return headers;
  }

  function getExportData() {
    if (!$scope.vacationData) return [];
    return $scope.vacationData.map((vacay) => {
      const row = [vacay.name];
      if (vacay.manglat) {
        vacay.manglat.forEach((week) => {
          const semCount = week.filter((day) => day.semester).length;
          const parCount = week.filter((day) => day.parentalLeave).length;
          row.push(semCount > 0 ? semCount : "");
          row.push(parCount > 0 ? parCount : "");
        });
      }
      return row;
    });
  }

  function old_processVacationData(data) {
    $scope.vacation = data.list;
    $scope.header.push(...data.weeks.map((week) => `V ${week}`));
  }

  function calculateColor(value) {
    const maxVal = 40;
    const minVal = 0;

    const maxColor = { r: 0, g: 102, b: 204 }; // Medium blue
    const minColor = { r: 230, g: 242, b: 255 }; // Light blue

    const ratio = value / maxVal;

    const r = Math.round(minColor.r + ratio * (maxColor.r - minColor.r));
    const g = Math.round(minColor.g + ratio * (maxColor.g - minColor.g));
    const b = Math.round(minColor.b + ratio * (maxColor.b - minColor.b));

    return `rgb(${r}, ${g}, ${b})`;
  }



  $scope.getClassForValue = function (value) {
    //console.log(value);
    if (Number.isInteger(value)) {
      if (value === 40) {
        return "value-40";
      } else if (value > 0) {
        return "value-between";
      }
    }
  };

  $scope.getStyleForValue = function (value) {
    if (value) return {
      "background-color": "rgb(102, 174, 246)",
    };
  }
}
